export default {
  // baseURL: 'http://127.0.0.1:8000/api',
  // baseURL: 'http://172.17.10.130/api',
  // baseURL: 'http://192.168.0.185:8000/api',
  // baseURL: 'http://172.20.10.6:8080/api',
  baseURL: 'https://dev-now-api.funda.kr/api',
  // adminURL: 'https://dev-now-api.funda.kr/_admin'
}
